export const FILTER_NAME = 'delivery_method'
